function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//@ts-nocheck

/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Animated, Easing, Platform } from 'react-native';
import { Animation } from "./animation";
const DEFAULT_CONFIG = {
  start: 1.0,
  end: 1.25,
  easing: Easing.linear,
  duration: 500,
  useNativeDriver: Platform.OS !== 'web'
};
export class PulseAnimation extends Animation {
  constructor(config) {
    super(_objectSpread(_objectSpread({}, DEFAULT_CONFIG), config));

    _defineProperty(this, "value", void 0);

    this.value = new Animated.Value(this.config.start);
  }

  get animation() {
    const _this$config = this.config,
          {
      start,
      end
    } = _this$config,
          restConfig = _objectWithoutProperties(_this$config, ["start", "end"]);

    const startAnimation = Animated.timing(this.value, _objectSpread({
      toValue: end
    }, restConfig));
    const endAnimation = Animated.timing(this.value, _objectSpread({
      toValue: start
    }, restConfig));
    return Animated.sequence([startAnimation, endAnimation]);
  }

  toProps() {
    return {
      // @ts-ignore: Animated.Value is not assignable to a number, but it is a number
      style: {
        transform: [{
          scale: this.value
        }]
      }
    };
  }

}